import React, { Component } from 'react';
import { CardActions } from '@material-ui/core';
import styled from 'styled-components';

import RainBowButton from './RainbowButton';
import DialogInput from './DialogInput';

const Actions = styled(CardActions)`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
	position: absolute;
`;

class CardAction extends Component {

    constructor() {
      super()
      this.state = {
        isAction: false,
      }
      this.showActionHandler = this.showActionHandler.bind(this)
      this.hideActionHandler = this.hideActionHandler.bind(this)
    }
  
    showActionHandler() {
      this.setState({
        isAction: true,
      })
    }
  
    hideActionHandler() {
      this.setState({
        isAction: false,
      })
    }
  
    render() {
      return(
        <Actions onMouseEnter={this.showActionHandler} onMouseLeave={this.hideActionHandler}>
          {
            this.state.isAction ?
              <div style={{width: '100%', height: '100%'}}>
                {!this.props.requireModal && <DialogInput onChange={this.props.update} onChange1={this.props.linkUpdate} onConfirm={this.props.confirm}/>}
                {this.props.requireModal && <RainBowButton
                    primary
                    style={{minWidth: 40, marginTop: 5}}
                    onClick={this.props.edit}
                  >{this.props.editButtonTitle || 'Edit'}</RainBowButton>
                }
                {!this.props.disableDelete && <RainBowButton
                  primary
                  // icon={<ActionDelete />}
                  style={{minWidth: '40px', marginTop:'5px'}}
                  onClick={this.props.delete}
                >Delete</RainBowButton>}
              </div>
            : null
          }
        </Actions>
      )
    }
}
  
export default CardAction;